import type {
  IChangePasswordRequest,
  IForgotPasswordRequest,
  ILogInRequest,
  IRegisterRequest,
  IResetPasswordRequest
} from '@treneo/models';
import { formFieldFactory } from '@treneo/shared/forms';

const loginFormField = formFieldFactory<ILogInRequest>();
export const loginFormFieldNames = {
  email: loginFormField('email'),
  password: loginFormField('password')
} as const;

const registerFormField = formFieldFactory<IRegisterRequest>();
export const registerFormFieldNames = {
  firstName: registerFormField('firstName'),
  lastName: registerFormField('lastName'),
  email: registerFormField('email'),
  password: registerFormField('password'),
  confirmPassword: registerFormField('confirmPassword'),
  acceptTermsAndPrivacyPolicy: registerFormField('acceptTermsAndPrivacyPolicy')
} as const;

const forgotPasswordFormField = formFieldFactory<IForgotPasswordRequest>();
export const forgotPasswordFormFieldNames = {
  email: forgotPasswordFormField('email')
} as const;

const resetPasswordFormField = formFieldFactory<IResetPasswordRequest>();
export const resetPasswordFormFieldNames = {
  hash: resetPasswordFormField('hash'),
  password: resetPasswordFormField('password'),
  confirmPassword: resetPasswordFormField('confirmPassword')
} as const;

type ChangePasswordFormData = IChangePasswordRequest & { confirmPassword: string };
const changePasswordFormField = formFieldFactory<ChangePasswordFormData>();
export const changePasswordFormFieldNames = {
  oldPassword: changePasswordFormField('oldPassword'),
  password: changePasswordFormField('password'),
  confirmPassword: changePasswordFormField('confirmPassword')
} as const;
